const options = {
  ilfMitigationTypes: [
    { value: 'Mitigation Bank', label: 'Mitigation Bank' },
    { value: 'In-lieu Fee', label: 'In-lieu Fee' },
  ],

  impactActivities: [
    {
      value: 'Conversion of waters type (forested wetland to emergent wetland, stream to lake)',
      label: 'Conversion of waters type (forested wetland to emergent wetland, stream to lake)',
    },
    { value: 'Discharge of dredged material', label: 'Discharge of dredged material' },
    { value: 'Discharge of fill material', label: 'Discharge of fill material' },
    { value: 'Dredging (Section 10)', label: 'Dredging (Section 10)' },
    { value: 'Ecological restoration', label: 'Ecological restoration' },
    {
      value: 'Other (Aquaculture, Work, Aerial or Submarine cable crossings)',
      label: 'Other (Aquaculture, Work, Aerial or Submarine cable crossings)',
    },
    { value: 'Removal (Sec 10 structures)', label: 'Removal (Sec 10 structures)' },
    { value: 'Structure (Sec 10 only)', label: 'Structure (Sec 10 only)' },
    { value: 'Transport of dredged material (Sec 103)', label: 'Transport of dredged material (Sec 103)' },
  ],

  impactResourceTypes: [
    { value: 'Harbor/Ocean', label: 'Harbor/Ocean' },
    { value: 'Lake', label: 'Lake' },
    { value: 'Non-Tidal Wetland', label: 'Non-Tidal Wetland' },
    { value: 'Pond', label: 'Pond' },
    { value: 'River/Stream', label: 'River/Stream' },
    { value: 'Tidal Wetland', label: 'Tidal Wetland' },
    { value: 'Other', label: 'Other' },
  ],

  inLieuFeeTypes: [
    { value: 'Acre Based', label: 'Acre Based' },
    { value: 'Linear Feet Based', label: 'Linear Feet Based' },
    { value: 'Assessment Based', label: 'Assessment Based' },
    { value: 'Advanced Credit', label: 'Advanced Credit' },
  ],

  mitigationBankTypes: [
    { value: 'Acre Based', label: 'Acre Based' },
    { value: 'Linear Feet Based', label: 'Linear Feet Based' },
    { value: 'Assessment Based', label: 'Assessment Based' },
  ],

  mitigationSubTypes: [
    { value: 'Establishment', label: 'Establishment' },
    { value: 'Re-establishment', label: 'Re-establishment' },
    { value: 'Enhancement', label: 'Enhancement' },
    { value: 'Rehabilitation', label: 'Rehabilitation' },
    { value: 'Preservation', label: 'Preservation' },
  ],

  prmMitigationTypes: [
    { value: 'Permittee Responsible On-site', label: 'On-site' },
    { value: 'Permittee Responsible Off-site', label: 'Off-site' },
    { value: 'Advanced Permittee Responsible Mitigation', label: 'Advanced' },
  ],
};

export default options;
